import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';


export default function CardHeader({ className, children, ...props }) {
  return (
    <div {...props} className={classNames(className, 'card-header')}>
      {children}
    </div>
  );
}

CardHeader.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
};
